module.exports = new __parcel__URL__("settings.9bfa4562.svg").toString();